import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import Blog from "./pages/Blog";
import BlogPost from "./pages/BlogPost";
import Verify from "./components/app/Verify";
import Landing from "./components/Landing";
import Home from "./components/Home";
import { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import ResetPassword from "./components/app/ResetPassword";

function App() {
  useEffect(() => {
    AOS.init({
      duration: 800,
      easing: "ease-out",
      mirror: true,
      once: false,
    });
  }, []);

  return (
    <Router>
      <div
        className="relative min-h-screen overflow-hidden
                   text-white font-family-sans
                   bg-gradient-to-t from-[rgba(0,0,0,0.9)] to-black
                   selection:text-white selection:bg-primary"
      >
        <Routes>
          {/* All routes wrapped inside Home */}
          <Route path="/" element={<Home />}>
            <Route index element={<Landing />} />
            <Route path="blog" element={<Blog />} />
            <Route path="blog/:slug" element={<BlogPost />} />

            {/* /app routes */}
            <Route path="app">
              <Route index element={<Navigate to="/" replace />} />
              <Route path="verify" element={<Verify />} />
              <Route path="reset" element={<ResetPassword />} />
            </Route>
          </Route>
        </Routes>
      </div>
    </Router>
  );
}

export default App;
